import { render, staticRenderFns } from "./Rights_Index.vue?vue&type=template&id=5d7d151c&scoped=true&"
import script from "./Rights_Index.vue?vue&type=script&lang=js&"
export * from "./Rights_Index.vue?vue&type=script&lang=js&"
import style0 from "./Rights_Index.vue?vue&type=style&index=0&id=5d7d151c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7d151c",
  null
  
)

export default component.exports